import React, { useState } from "react";
import EyeIcon from "../icons/eyeIcon"
import InputMask from 'react-input-mask';

export default props => {
    const [visible, setVisible] = useState(false);

    function switchVisibility() {
        if (props.type === "password") {
            setVisible(!visible)
        }
    }

    function defineType() {
        if (props.type === "password" && !visible) {
            return "password";
        } else if (props.type === "password" && visible) {
            return "text";
        } else {
            return props.type
        }
    }

    return (
        <div style={props.style}>
            <div className={`account-input-container ${props.hasError ? "error" : " "}`}  >
                <label htmlFor={props.name} className={"account-input-label"}>{props.labelText}</label>
                <InputMask
                    mask={props.mask}
                    id={props.id}
                    name={props.name}
                    type={defineType()} 
                    className={`account-input ${props.disabled ? "disabled" : " "}`} 
                    value={props.value || ""}
                    readOnly={props.readOnly} 
                    onChange={props.onChange} 
                    onBlur={props.onBlur} 
                    disabled={props.disabled}/>
                {props.type === "password" ?
                    <span className={"account-eye-span"}>
                        <a onClick={() => switchVisibility()} ><EyeIcon className={"account-eye"} /></a>
                    </span> : null}
            </div>
            <span className={`span-display
                 ${props.hasError ? "span-display-block span-display-error" : " "}
                 ${props.hasInfo ? "span-display-block span-display-info" : " "}`}
            >{props.hasError || props.hasInfo ? props.error : " "}</span>
        </div>
    )
}
